import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import CompanyOverview from '../components/HomePageSections/CompanyOverview';
import FeaturedProjects from '../components/HomePageSections/FeaturedProjects';
import ServicesOffered from '../components/HomePageSections/ServicesOffered';
import { listGalleryImages } from '../services/awsService';

// TODO: Consider adding a testimonials section
// TODO: Add animation on scroll for sections

const HomePage = () => {
  const [featuredImage, setFeaturedImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGalleryImage = async () => {
      console.log('[HomePage] Loading gallery image for hero section...');
      try {
        const images = await listGalleryImages();
        if (images && images.length > 0) {
          console.log('[HomePage] Featured image loaded:', images[0].name);
          setFeaturedImage(images[0]);
        }
      } catch (error) {
        console.error('[HomePage] Error loading gallery image:', error);
      } finally {
        setLoading(false);
      }
    };

    loadGalleryImage();
  }, []);

  return (
    <>
      <Helmet>
        <title>DD Construction | Quality Home Building & Renovations in South Africa</title>
        <meta name="description" content="DD Construction delivers quality residential construction, home renovations, and building services in South Africa. 25+ years of experience. Licensed and insured professionals." />
        <meta property="og:title" content="DD Construction | Quality Home Building & Renovations in South Africa" />
        <meta property="og:description" content="DD Construction delivers quality residential construction, home renovations, and building services in South Africa." />
        <meta property="og:url" content="https://www.ddconstruction.co.za/" />
        <link rel="canonical" href="https://www.ddconstruction.co.za/" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-5 mb-lg-0">
              <h1>
                Building <span className="accent">Excellence</span>,<br />
                Delivering Quality
              </h1>
              <p className="lead mb-5">
                DD Construction provides professional residential construction
                services for your home building and renovation needs. With over
                25 years of experience, we bring your vision to life with
                quality craftsmanship and attention to detail.
              </p>
              <div className="d-flex gap-3 flex-wrap">
                <Button as={Link} to="/contact" variant="primary" size="lg">
                  Get a Quote
                </Button>
                <Button
                  as={Link}
                  to="/gallery"
                  variant="outline-primary"
                  size="lg"
                >
                  View Our Work
                </Button>
              </div>
            </Col>
            <Col lg={6}>
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center bg-light-gray rounded"
                  style={{ height: '400px' }}
                >
                  <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading image...</span>
                  </Spinner>
                </div>
              ) : featuredImage ? (
                <img
                  src={featuredImage.url}
                  alt={featuredImage.name || 'Featured residential construction project'}
                  className="img-fluid hero-image"
                />
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center bg-light-gray rounded"
                  style={{ height: '400px' }}
                >
                  <img
                    src="/assets/dd_logo_transparent.png"
                    alt="DD Construction"
                    style={{ maxHeight: '200px', opacity: 0.5 }}
                  />
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>

      <Container>
        {/* Company Overview Section */}
        <CompanyOverview />

        {/* Featured Projects Section */}
        <FeaturedProjects />

        {/* Services Section */}
        <ServicesOffered />

        {/* Call to Action Section */}
        <section className="cta-section my-5">
          <h2>Ready to Start Your Home Project?</h2>
          <p className="lead">
            Contact us today for a free consultation and estimate on your
            residential construction project. Whether it's a new home,
            renovation, or addition, we're here to help.
          </p>
          <Button as={Link} to="/contact" variant="primary" size="lg">
            Get in Contact
          </Button>
        </section>
      </Container>
    </>
  );
};

export default HomePage;
